import { MenuItem } from '@material-ui/core';
import React from 'react';
import { useForm } from 'react-hook-form';
import { connect } from 'react-redux';
import * as yup from 'yup';
import TextInputController from '../../../../components/Inputs/TextInputController/TextInputController';
import TransitionModal from '../../../../components/Modal/TransitionModal';
import SelectController from '../../../../components/Select/SelectController';
import { tFormKey, tKey } from '../../../../helpers/translate';
import { rejectInvoiceAction } from '../../../../redux/accounting/actions';
import { CodeNamePair } from '../../../../redux/common/definitions';
import styles from './rejectInvoiceModal.module.scss';
import useRejectInvoices from './useRejectInvoices';

interface RejectInvoiceModalProps {
  show: boolean;
  invoice_id: number;
  current_state: string;
  rejectInvoice: (invoice_id: number, current_state: string, next_state: string, comment: string) => void;
  handleClose: () => void;
}

const rejectInvoiceModalSchema = yup.object().shape({
  next_state: yup.string(),
  message: yup.string().required('Se debe indicar el motivo del rechazo'),
});

interface RejectInvoiceModalData {
  next_state: string;
  message: string;
}

const RejectInvoiceModal: React.FC<RejectInvoiceModalProps> = ({
  show,
  invoice_id,
  current_state,
  rejectInvoice,
  handleClose,
}) => {
  const { selectNextState } = useRejectInvoices();
  const { errors, handleSubmit, control } = useForm<RejectInvoiceModalData>({
    mode: 'onSubmit',
    submitFocusError: true,
    validationSchema: rejectInvoiceModalSchema,
  });

  const onSend = (data: RejectInvoiceModalData) => {
    rejectInvoice(invoice_id, current_state, data.next_state, data.message);
    handleClose();
  };

  const rejectStates = selectNextState(current_state);

  return (
    <TransitionModal
      view={show}
      handleClose={handleClose}
      title={tFormKey('Motivo del retroceso')}
      buttonOk={tFormKey('Retroceder')}
      buttonKo={tKey('Cancelar')}
      handleYes={handleSubmit(onSend)}
      handleNo={handleClose}
    >
      <div className={styles.modal_content}>
        <SelectController
          control={control}
          name="next_state"
          size={50}
          defaultValue={rejectStates.defaultCode}
          errors={errors}
          schema={rejectInvoiceModalSchema}
          label={tFormKey('Retroceder a estado')}
        >
          {rejectStates.nextStates.map((state: CodeNamePair) => (
            <MenuItem key={state.code} value={state.code}>
              {state.name}
            </MenuItem>
          ))}
        </SelectController>
        <TextInputController
          name="message"
          control={control}
          label={tFormKey('Motivo')}
          fullWidth
          multiline
          rows="5"
          rowsMax="5"
          errors={errors}
          schema={rejectInvoiceModalSchema}
        />
      </div>
    </TransitionModal>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  rejectInvoice: (invoice_id: number, current_state: string, next_state: string, comment: string): void =>
    dispatch(rejectInvoiceAction(invoice_id, current_state, next_state, comment)),
});

export default connect(undefined, mapDispatchToProps)(RejectInvoiceModal);
